"use client";

import { createSVGIcon } from "@faire/web/slate/icons/util";
import React from "react";

/** @optimized using svgo:^3.0.2 */
export const Language = createSVGIcon(
  <>
    <path
      d="m3.77 11.756 3.312-7.733a.411.411 0 0 1 .76 0l3.312 7.733M5.257 8.284h4.41"
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.315 1.315A1.08 1.08 0 0 0 1 2.077v10.846a1 1 0 0 0 1 1h10.847a1.077 1.077 0 0 0 1.076-1.077V2.076A1.077 1.077 0 0 0 12.846 1H2.076c-.285 0-.559.113-.76.315Z"
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.077 14v10a1 1 0 0 0 1 1h10.847A1.077 1.077 0 0 0 25 23.923V13.154a1.077 1.077 0 0 0-1.077-1.077H14M22.23 16.486h-7.384m3.692-1.64v1.64m-2.461 0L21 22.23m0-5.744-4.923 5.744M17.459 4.98l-1.221-.838.838-1.221m-.838 1.22a4.87 4.87 0 0 1 5.277 1.088 4.33 4.33 0 0 1 .556 4.913M8.739 21.424l1.22.838-.838 1.221m.838-1.22a4.87 4.87 0 0 1-5.277-1.088 4.33 4.33 0 0 1-.556-4.913"
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Language",
  { viewBox: "0 0 26 26", titleAccess: "Language", fill: "none" }
);
